import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import enAdmin from "#/locales/en/admin.json";
import enBrowse from "#/locales/en/browse.json";
import enCommon from "#/locales/en/common.json";
import enError from "#/locales/en/error.json";
import enHome from "#/locales/en/home.json";
import enLegal from "#/locales/en/legal.json";
import enListingDetail from "#/locales/en/listingDetail.json";
import enListings from "#/locales/en/listings.json";
import enMessages from "#/locales/en/messages.json";
import enMyListings from "#/locales/en/myListings.json";
import enReport from "#/locales/en/report.json";
import enReview from "#/locales/en/review.json";
import enSell from "#/locales/en/sell.json";
import enSellerProfile from "#/locales/en/sellerProfile.json";
import enSettings from "#/locales/en/settings.json";
import enWatchlist from "#/locales/en/watchlist.json";
import fiAdmin from "#/locales/fi/admin.json";
import fiBrowse from "#/locales/fi/browse.json";
import fiCommon from "#/locales/fi/common.json";
import fiError from "#/locales/fi/error.json";
import fiHome from "#/locales/fi/home.json";
import fiLegal from "#/locales/fi/legal.json";
import fiListingDetail from "#/locales/fi/listingDetail.json";
import fiListings from "#/locales/fi/listings.json";
import fiMessages from "#/locales/fi/messages.json";
import fiMyListings from "#/locales/fi/myListings.json";
import fiReport from "#/locales/fi/report.json";
import fiReview from "#/locales/fi/review.json";
import fiSell from "#/locales/fi/sell.json";
import fiSellerProfile from "#/locales/fi/sellerProfile.json";
import fiSettings from "#/locales/fi/settings.json";
import fiWatchlist from "#/locales/fi/watchlist.json";

function getInitialLanguage(): string {
	try {
		const saved = localStorage.getItem("i18n-language");
		if (saved && ["en", "fi"].includes(saved)) return saved;
		const browser = navigator.language.split("-")[0];
		const lang = ["en", "fi"].includes(browser) ? browser : "en";
		localStorage.setItem("i18n-language", lang);
		return lang;
	} catch {
		return "en";
	}
}

i18n.use(initReactI18next).init({
	lng: getInitialLanguage(),
	resources: {
		en: {
			common: enCommon,
			home: enHome,
			listings: enListings,
			listingDetail: enListingDetail,
			sell: enSell,
			myListings: enMyListings,
			watchlist: enWatchlist,
			messages: enMessages,
			settings: enSettings,
			sellerProfile: enSellerProfile,
			admin: enAdmin,
			browse: enBrowse,
			report: enReport,
			review: enReview,
			error: enError,
			legal: enLegal,
		},
		fi: {
			common: fiCommon,
			home: fiHome,
			listings: fiListings,
			listingDetail: fiListingDetail,
			sell: fiSell,
			myListings: fiMyListings,
			watchlist: fiWatchlist,
			messages: fiMessages,
			settings: fiSettings,
			sellerProfile: fiSellerProfile,
			admin: fiAdmin,
			browse: fiBrowse,
			report: fiReport,
			review: fiReview,
			error: fiError,
			legal: fiLegal,
		},
	},
	fallbackLng: "en",
	defaultNS: "common",
	supportedLngs: ["en", "fi"],
	interpolation: { escapeValue: false },
	initImmediate: false,
	react: { useSuspense: false },
});

export function detectAndApplyLanguage() {
	// Language is set at init time — this is a no-op kept for call-site compatibility.
}

export default i18n;
